// Which section's sub-items are showing in a section tree.
//
// The viewer can open any section, but the answer has to fall back to the one
// they are standing in whenever the route moves — otherwise a tree left open
// on Customers stays open on Customers after navigating into Operations. The
// override records the section it was made against, so a new active section
// invalidates it without an effect or a reset call.

import { useState } from 'react';

import type { SectionId } from './config';

interface Override {
  base: SectionId | null;
  value: SectionId | null;
}

export function useExpandedSection(activeSection: SectionId | null): {
  expanded: SectionId | null;
  toggle: (id: SectionId) => void;
} {
  const [override, setOverride] = useState<Override | null>(null);
  const expanded = override && override.base === activeSection ? override.value : activeSection;

  return {
    expanded,
    toggle: (id) => setOverride({ base: activeSection, value: expanded === id ? null : id }),
  };
}
